"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetFeatures = createGetFeatures;
exports.createGetFeaturesReverse = createGetFeaturesReverse;

var _http = require("../http");

var _config = require("../config");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getPositionParamsFromGeolocationResult(coords) {
  if (!coords) {
    return;
  }

  var latitude = coords.latitude,
      longitude = coords.longitude;
  return {
    'focus.point.lat': latitude,
    'focus.point.lon': longitude
  };
}

function stringifyCommaSeparatedList(value) {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  return value.join(',');
}

function transformBoundaryParam(boundary) {
  if (!boundary) return {};
  var result = {
    'boundary.country': boundary.country,
    'boundary.county_ids': stringifyCommaSeparatedList(boundary.countyIds),
    'boundary.locality_ids': stringifyCommaSeparatedList(boundary.localityIds)
  };

  if (boundary.rect) {
    result = _objectSpread(_objectSpread({}, result), {}, {
      'boundary.rect.min_lat': boundary.rect.minLat,
      'boundary.rect.min_lon': boundary.rect.minLon,
      'boundary.rect.max_lat': boundary.rect.maxLat,
      'boundary.rect.max_lon': boundary.rect.maxLon
    });
  }

  return result;
}

function createGetFeatures(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getFeatures(text, coords) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _getGeocoderHost = (0, _config.getGeocoderHost)(config),
        host = _getGeocoderHost.host,
        headers = _getGeocoderHost.headers;

    var sources = params.sources,
        layers = params.layers,
        limit = params.limit,
        boundary = params.boundary,
        rest = _objectWithoutProperties(params, ["sources", "layers", "limit", "boundary"]);

    var searchParams = _objectSpread(_objectSpread(_objectSpread({
      text: text,
      lang: 'no'
    }, getPositionParamsFromGeolocationResult(coords)), transformBoundaryParam(boundary)), {}, {
      sources: stringifyCommaSeparatedList(sources),
      layers: stringifyCommaSeparatedList(layers),
      size: limit
    }, rest);

    var url = "".concat(host, "/autocomplete");
    return (0, _http.get)(url, searchParams, headers, undefined, config.fetch).then(function (data) {
      return data.features || [];
    });
  };
}

function createGetFeaturesReverse(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getFeaturesReverse(coords) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _getGeocoderHost2 = (0, _config.getGeocoderHost)(config),
        host = _getGeocoderHost2.host,
        headers = _getGeocoderHost2.headers;

    var searchParams = {
      'point.lat': coords.latitude,
      'point.lon': coords.longitude,
      'boundary.circle.radius': params.radius,
      size: params.size,
      layers: params.layers && Array.isArray(params.layers) ? params.layers.join(',') : undefined
    };
    var url = "".concat(host, "/reverse");
    return (0, _http.get)(url, searchParams, headers, undefined, config.fetch).then(function (data) {
      return data.features || [];
    });
  };
}